var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKabaddi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    height: 20,
    width: "20px",
    id: "Layer_1",
    viewBox: "0 0 475 475",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,105v4.9V370h475V105H0z M242.6,115.1h222.3v45H242.6V115.1z M412.4,169.8v134.9H385V169.8H412.4z M374.9,169.8v134.9    H242.6V169.8H374.9z M232.4,359.9H10.1v-45h222.3V359.9z M10.1,304.7V169.8h42.4v134.9H10.1z M62.6,304.7V169.8H90v134.9H62.6z     M232.4,304.7H100.1V169.8h132.3V304.7z M232.4,160.1H10.1v-45h222.3V160.1z M464.9,359.9H242.6v-45h222.3V359.9z M464.9,304.7    h-42.4V169.8h42.4V304.7z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabaddi);
export default __webpack_public_path__ + "static/media/kabaddi.7d803f73b5cc924e27b0eacaf8c78a3c.svg";
export { ForwardRef as ReactComponent };